import { Component } from "react";

class Arrow extends Component {
  render() {
    return (
      <span className="text-orange">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" stroke="none" viewBox="-7 -5 20 20">
        <path
     fillRule="evenodd"
     d="M 1.4147953,0.9998489 A 1,1 0 0 1 2.4146443,0 h 8.4852807 a 1,1 0 0 1 0.999849,0.9998489 v 8.4852813 a 1,1 0 0 1 -1.9996976,0 V 3.4139115 L 1.7075375,11.60645 A 1,1 0 1 1 0.29332393,10.192237 L 8.4858634,1.9996979 H 2.4146443 a 1,1 0 0 1 -0.999849,-0.999849 z"
     clipRule="evenodd"
     id="path2" />
        </svg>
      </span>
    );
  }
}

export default Arrow;

